/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL2(props) {
  return (
    <div
      className={`s-ou-l2 ${css(
        styles.content_box,
        styles.content_box_layout
      )}`}
    >
      <Px.div
        style={{
          '--src': `url(${
            require('assets/df026b574aa41cf456071ab8f725f225.png').default
          })`
        }}
        x="0px 517px 923fr"
        y="895fr 708px 0px"
        absolute
        className={css(styles.image)}
        smX="0px 517px 923fr"
        smY="895fr 708px 0px"
        smDisplay="none"
      />
      <Px.div
        style={{
          '--src': `url(${
            require('assets/0f313ba6fe4c08051fd6a62f5c7b1564.png').default
          })`
        }}
        x="924fr 516px 0px"
        y="895fr 708px 0px"
        absolute
        className={css(styles.image)}
        smX="924fr 516px 0px"
        smY="895fr 708px 0px"
        smDisplay="none"
      />

      <div className={css(styles.content, styles.content_layout)}>
        <div className={css(styles.content_item)}>
          <div className={css(styles.group, styles.group_layout)}>
            {/* TODO: replace with Header */}
            {/* reserved block */}
            <HeaderBlack />
          </div>
        </div>
        <div className={css(styles.content_item1)}>
          <div
            style={{
              '--src': `url(${
                require('assets/48d6a2322ae48b4797de9cdc55b66313.png').default
              })`
            }}
            className={css(styles.cover_group, styles.cover_group_layout)}
          >
            <div
              style={{
                '--src': `url(${
                  require('assets/dd2dbed68a000b52073c289d092dda2b.png').default
                })`
              }}
              className={css(styles.image2, styles.image2_layout)}
            />
          </div>
        </div>
        <h4 className={css(styles.highlights, styles.highlights_layout)}>
          {'你/妳的靈魂是'}
        </h4>
        <h1 className={css(styles.big_title, styles.big_title_layout)}>
          {'有故事的溫柔職人'}
        </h1>
        <div className={css(styles.content_item2)}>
          <h5 className={css(styles.highlights1, styles.highlights1_layout)}>
            {
              '眼神堅定而溫柔，雙手上的痕跡是日日夜夜堅持的證據，默默堅守一輩子所追逐的信仰。你一句話也沒說，也不須說，一切無聲勝有聲。背影隱藏過去堆疊厚厚的記憶，所感觸的情緒早已超出了言語。'
            }
          </h5>
        </div>
        <div className={css(styles.content_item3)}>
          <div
            onClick={() => window.open('/soul', '_self')}
            className={`${css(
              styles.cover_group1,
              styles.cover_group1_layout
            )} cursor-pointer to-more`}
          >
            <h5 className={css(styles.highlights2, styles.highlights2_layout)}>
              {'五感靈魂樣貌'}
            </h5>
          </div>
        </div>
        <div className={css(styles.content_item4)}>
          <div
            style={{
              '--src': `url(${
                require('assets/88ff9a5d00dd21b3757f724fbc400b1f.png').default
              })`
            }}
            className={css(styles.image3, styles.image3_layout)}
          />
        </div>
        <h4 className={css(styles.highlights3, styles.highlights3_layout)}>
          {'專屬於你的風味想像'}
        </h4>
        <div className={css(styles.content_item5)}>
          <div
            className={css(styles.paragraph_body, styles.paragraph_body_layout)}
          >
            {
              '森林裡月光灑在這片安靜的大地，氣溫不會冷、也不會熱。可以清楚看見樹皮的質感，摸著樹皮往前，遠處隱約有一位男性的背影。他的衣著樸素，卻擁有富裕的內心，他一個人、沒有別人，但心裡有滿滿的愛。煙燻裊裊，吹來一陣懷舊的灰風。'
            }
          </div>
        </div>
        <h4 className={css(styles.highlights4, styles.highlights4_layout)}>
          {'推薦給你：營火旁的茶・炭焙有機紅烏龍'}
        </h4>
        <div className={css(styles.content_item6)}>
          <div
            className={css(
              styles.paragraph_body,
              styles.paragraph_body_layout1
            )}
          >
            {
              '這一款茶是中性的，職人的靈魂以厚重煙燻的氣味展現。安穩的炭火想像，可以讓你提高專注力。就像火烤奶茶、煙燻烤肉、木桶裡滾動的威士忌。'
            }
          </div>
        </div>
        <div className={css(styles.content_item7)}>
          <div className={css(styles.flex, styles.flex_layout)}>
            <div className={css(styles.flex_item)}>
              <div
                className={css(styles.cover_group2, styles.cover_group2_layout)}
              >
                {'風味標籤'}
              </div>
            </div>
            <div className={css(styles.flex_spacer)} />
            <div className={css(styles.flex_item1)}>
              <div
                className={css(
                  styles.small_paragraph_body,
                  styles.small_paragraph_body_layout
                )}
              >
                {'重烘焙可可、煙燻乾草、龍眼乾、橡木桶、堅果、磚與泥土'}
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.content_item8)}>
          <div className={css(styles.flex, styles.flex_layout)}>
            <div className={css(styles.flex1_item)}>
              <div
                className={css(styles.cover_group3, styles.cover_group3_layout)}
              >
                {'茶體'}
              </div>
            </div>
            <div className={css(styles.flex1_spacer)} />
            <div
              className={css(
                styles.small_text_body,
                styles.small_text_body_layout
              )}
            >
              {'飽滿'}
            </div>
            <div className={css(styles.flex1_spacer1)} />
            <div className={css(styles.flex1_item1)}>
              <div className={css(styles.flex2, styles.flex2_layout)}>
                <div
                  style={{
                    '--src': `url(${
                      require('assets/5d5a44ecbb4d958d8d61e02582ee8db3.svg')
                        .default
                    })`
                  }}
                  className={css(styles.image4, styles.image4_layout)}
                />
                <div
                  style={{
                    '--src': `url(${
                      require('assets/3f54158eb3ee2b7a4e2d9b8e626f44ce.svg')
                        .default
                    })`
                  }}
                  className={css(styles.image5, styles.image5_layout)}
                />
                <div
                  style={{
                    '--src': `url(${
                      require('assets/01019050e515b40cec7ead6f9c412f8e.svg')
                        .default
                    })`
                  }}
                  className={css(styles.image6, styles.image6_layout)}
                />
                <div className={css(styles.flex2_spacer)} />
                <div
                  style={{
                    '--src': `url(${
                      require('assets/878e0c5a4613ce08e0781a0a8ff386a0.svg')
                        .default
                    })`
                  }}
                  className={css(styles.image7, styles.image7_layout)}
                />
                <div className={css(styles.flex2_item)}>
                  <div className={css(styles.group1, styles.group1_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/67e4c5bdfa092b60dc141941a7ede125.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image8, styles.image8_layout)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.content_item9)}>
          <div className={css(styles.flex, styles.flex_layout)}>
            <div className={css(styles.flex3_item)}>
              <div
                className={css(styles.cover_group4, styles.cover_group4_layout)}
              >
                {'泡法'}
              </div>
            </div>
            <div className={css(styles.flex3_spacer)} />
            <div className={css(styles.flex3_item1)}>
              <div className={css(styles.flex4, styles.flex4_layout)}>
                <div className={css(styles.flex4_item)}>
                  <div className={css(styles.flex, styles.flex_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/8256fb8e4c4e8d1cbccf18b12b20b940.png')
                            .default
                        })`
                      }}
                      className={css(styles.image9, styles.image9_layout)}
                    />
                    <div className={css(styles.flex5_spacer)} />
                    <div
                      className={css(
                        styles.small_text_body1_box,
                        styles.small_text_body1_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body1)}>
                        <span className={css(styles.small_text_body1_span0)}>
                          {'200ml'}
                        </span>
                        <span className={css(styles.small_text_body1_span1)}>
                          {' 熱泡'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body2_box,
                    styles.small_text_body2_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body2)}>
                    <span className={css(styles.small_text_body2_span0)}>
                      {'茶葉 '}
                    </span>
                    <span className={css(styles.small_text_body2_span1)}>
                      {'3g'}
                    </span>
                    <span className={css(styles.small_text_body2_span2)}>
                      {' / 茶包'}
                    </span>
                    <span className={css(styles.small_text_body2_span3)}>
                      {'1'}
                    </span>
                    <span className={css(styles.small_text_body2_span4)}>
                      {'個'}
                    </span>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body3_box,
                    styles.small_text_body3_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body3)}>
                    <span className={css(styles.small_text_body3_span0)}>
                      {'水溫：'}
                    </span>
                    <span className={css(styles.small_text_body3_span1)}>
                      {'95-98°C'}
                    </span>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body4_box,
                    styles.small_text_body4_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body4)}>
                    <span className={css(styles.small_text_body4_span0)}>
                      {'時間：'}
                    </span>
                    <span className={css(styles.small_text_body4_span1)}>
                      {'2'}
                    </span>
                    <span className={css(styles.small_text_body4_span2)}>
                      {'分鐘'}
                    </span>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body5_box,
                    styles.small_text_body5_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body5)}>
                    <span className={css(styles.small_text_body5_span0)}>
                      {'回沖：'}
                    </span>
                    <span className={css(styles.small_text_body5_span1)}>
                      {'3'}
                    </span>
                    <span className={css(styles.small_text_body5_span2)}>
                      {'次'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={css(styles.flex3_spacer1)} />
            <div className={css(styles.flex3_item2)}>
              <div className={css(styles.flex6, styles.flex6_layout)}>
                <div className={css(styles.flex6_item)}>
                  <div className={css(styles.flex, styles.flex_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/cad9bcf9ad1371a1a2b9462ed3feb802.png')
                            .default
                        })`
                      }}
                      className={css(styles.image10, styles.image10_layout)}
                    />
                    <div className={css(styles.flex7_spacer)} />
                    <div
                      className={css(
                        styles.small_text_body6_box,
                        styles.small_text_body6_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body6)}>
                        <span className={css(styles.small_text_body6_span0)}>
                          {'300ml'}
                        </span>
                        <span className={css(styles.small_text_body6_span1)}>
                          {' 熱泡'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body7_box,
                    styles.small_text_body7_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body7)}>
                    <span className={css(styles.small_text_body7_span0)}>
                      {'茶葉 '}
                    </span>
                    <span className={css(styles.small_text_body7_span1)}>
                      {'3g'}
                    </span>
                    <span className={css(styles.small_text_body7_span2)}>
                      {' / 茶包'}
                    </span>
                    <span className={css(styles.small_text_body7_span3)}>
                      {'1'}
                    </span>
                    <span className={css(styles.small_text_body7_span4)}>
                      {'個'}
                    </span>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body8_box,
                    styles.small_text_body8_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body8)}>
                    <span className={css(styles.small_text_body8_span0)}>
                      {'水溫：'}
                    </span>
                    <span className={css(styles.small_text_body8_span1)}>
                      {'95-98°C'}
                    </span>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body9_box,
                    styles.small_text_body9_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body9)}>
                    <span className={css(styles.small_text_body9_span0)}>
                      {'時間：'}
                    </span>
                    <span className={css(styles.small_text_body9_span1)}>
                      {'3'}
                    </span>
                    <span className={css(styles.small_text_body9_span2)}>
                      {'分鐘'}
                    </span>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body10_box,
                    styles.small_text_body10_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body10)}>
                    <span className={css(styles.small_text_body10_span0)}>
                      {'回沖'}
                    </span>
                    <span className={css(styles.small_text_body10_span1)}>
                      {'：'}
                    </span>
                    <span className={css(styles.small_text_body10_span2)}>
                      {'2'}
                    </span>
                    <span className={css(styles.small_text_body10_span3)}>
                      {'次'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.content_item10)}>
          <div
            onClick={() =>
              window.open(
                'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=9'
              )
            }
            className={`${css(
              styles.cover_group5,
              styles.cover_group5_layout
            )} cursor-pointer to-more`}
          >
            {'了解更多'}
          </div>
        </div>
        <div className={css(styles.content_item11)}>
          <div
            onClick={() => window.open('/', '_self')}
            className={`${css(
              styles.cover_group6,
              styles.cover_group6_layout
            )} cursor-pointer to-home`}
          >
            {'重新探索'}
          </div>
        </div>
      </div>
    </div>
  );
}

SOUL2.inStorybook = true;

const styles = StyleSheet.create({
  content_box: {
    display: 'flex',
    backgroundColor: 'rgba(132,70,49,0.2)',
    borderRadius: '0px 0px 0px 0px'
  },
  content_box_layout: {
    position: 'relative',
    overflow: 'hidden visible',
    minHeight: 1603,
    flexGrow: 1
  },
  image: {
    background: 'var(--src) center center / contain no-repeat',
    width: '100%',
    height: '100%',
    opacity: 0.15
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  content_layout: {
    position: 'relative',
    width: 352,
    minWidth: 352,
    margin: '54px auto 53px'
  },
  content_item: {
    display: 'flex',
    flex: '0 1 29px'
  },
  group: {},
  group_layout: {
    position: 'relative',
    height: 29,
    flexGrow: 1,
    margin: '0px 18px 0px 1px'
  },
  content_item1: {
    display: 'flex',
    flex: '0 1 297px'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group_layout: {
    position: 'relative',
    minHeight: 257,
    flexGrow: 1,
    margin: '40px 8px 0px 1px'
  },
  image2: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image2_layout: {
    height: 115,
    width: 130,
    minWidth: 130,
    margin: '83px 0px 59px 48px'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px',
    opacity: 0.69875
  },
  highlights_layout: {
    flex: '1 0 auto',
    margin: '15px 0px 0px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  big_title_layout: {
    flex: '1 0 auto',
    margin: '14px 0px 0px'
  },
  content_item2: {
    display: 'flex',
    flex: '0 1 168px'
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    flexGrow: 1,
    margin: '28px 1px 0px 0px'
  },
  content_item3: {
    display: 'flex',
    flex: '0 1 54px'
  },
  cover_group1: {
    display: 'flex',
    backgroundColor: 'rgb(95,118,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '10px 9px 0px 0px'
  },
  highlights2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    width: 100,
    minWidth: 100,
    margin: '8px auto'
  },
  content_item4: {
    display: 'flex',
    flex: '0 1 302px'
  },
  image3: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image3_layout: {
    height: 257,
    flexGrow: 1,
    margin: '45px 5px 0px 3px'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    flex: '1 0 auto',
    margin: '19.5px 1px 0px'
  },
  content_item5: {
    display: 'flex',
    flex: '0 1 115.5px'
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    flexGrow: 1,
    margin: '5.5px 0px 0px 1px'
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    flex: '1 0 auto',
    margin: '45px 1px 0px'
  },
  content_item6: {
    display: 'flex',
    flex: '0 1 81px'
  },
  paragraph_body_layout1: {
    flexGrow: 1,
    margin: '15px 0px 0px 1px'
  },
  content_item7: {
    display: 'flex',
    flex: '0 1 56px'
  },
  flex: {
    display: 'flex'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group2: {
    display: 'flex',
    backgroundColor: 'rgb(131,170,190)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 2px 0px 2px'
  },
  cover_group2_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '16px 0px 20px 1px'
  },
  flex_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex_item1: {
    display: 'flex',
    flex: '1 1 284px'
  },
  small_paragraph_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_paragraph_body_layout: {
    flexGrow: 1,
    margin: '16px 2px 0px 0px'
  },
  content_item8: {
    display: 'flex',
    flex: '0 1 30px'
  },
  flex1_item: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group3: {
    display: 'flex',
    backgroundColor: 'rgb(131,170,190)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 14px 0px 14px'
  },
  cover_group3_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 0px 1px'
  },
  flex1_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  small_text_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    margin: '10px 0px 0px'
  },
  flex1_spacer1: {
    flex: '0 0 auto',
    minWidth: 6
  },
  flex1_item1: {
    display: 'flex',
    flex: '0 1 251px'
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '12px 0px 0px'
  },
  image4: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image4_layout: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px'
  },
  image5: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image5_layout: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px'
  },
  image6: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image6_layout: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px'
  },
  flex2_spacer: {
    flex: '0 0 auto',
    minWidth: 1
  },
  image7: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image7_layout: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px'
  },
  flex2_item: {
    display: 'flex',
    flex: '0 1 198px'
  },
  group1: {
    display: 'flex',
    opacity: 0.20473747
  },
  group1_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 184px 0px 0px'
  },
  image8: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image8_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  content_item9: {
    display: 'flex',
    flex: '0 1 110px'
  },
  flex3_item: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group4: {
    display: 'flex',
    backgroundColor: 'rgb(131,170,190)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 14px 0px 14px'
  },
  cover_group4_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 89px 1px'
  },
  flex3_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex3_item1: {
    display: 'flex',
    flex: '0 1 95px'
  },
  flex4: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex4_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '10px 0px 0px'
  },
  flex4_item: {
    display: 'flex',
    flex: '0 1 20px'
  },
  image9: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image9_layout: {
    flex: '0 1 18px',
    height: 11,
    width: 18,
    minWidth: 18,
    margin: '5px 0px 4px'
  },
  flex5_spacer: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body1: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body1_box: {},
  small_text_body1_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body1_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body1_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body2: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body2_box: {},
  small_text_body2_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body2_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body2_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body2_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body2_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body2_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body3: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body3_box: {},
  small_text_body3_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body3_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body3_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body4: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body4_box: {},
  small_text_body4_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body4_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body4_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body4_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  flex3_spacer1: {
    flex: '0 0 auto',
    minWidth: 29
  },
  flex3_item2: {
    display: 'flex',
    flex: '0 1 160px'
  },
  flex6: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex6_layout: {
    position: 'relative',
    width: 95,
    minWidth: 95,
    margin: '10px 0px 0px'
  },
  flex6_item: {
    display: 'flex',
    flex: '0 1 20px'
  },
  image10: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image10_layout: {
    flex: '0 1 18px',
    height: 13,
    width: 18,
    minWidth: 18,
    margin: '4px 0px 3px'
  },
  flex7_spacer: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body6: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body6_box: {},
  small_text_body6_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body6_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body6_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body7: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body7_box: {},
  small_text_body7_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body7_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body7_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body7_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body7_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body7_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body8: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body8_box: {},
  small_text_body8_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body8_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body8_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body9: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body9_box: {},
  small_text_body9_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body9_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body9_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body9_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body10: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(18,18,18)',
    letterSpacing: '0px'
  },
  small_text_body10_box: {},
  small_text_body10_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body10_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body10_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body10_span2: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  small_text_body10_span3: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#121212ff',
    letterSpacing: '0px'
  },
  content_item10: {
    display: 'flex',
    flex: '0 1 56px'
  },
  cover_group5: {
    display: 'flex',
    backgroundColor: 'rgb(95,118,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.6 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group5_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '12px 8px 0px 1px'
  },
  content_item11: {
    display: 'flex',
    flex: '0 1 44px'
  },
  cover_group6: {
    display: 'flex',
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.6 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group6_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '16px 8px 0px 1px'
  }
});
